import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { registerServiceWorker } from "./utils/registerSW";
import i18n from "./i18n";

// Set initial html lang from i18n detected language
document.documentElement.lang = i18n.language || 'pt-BR';

// Update html lang whenever language changes
i18n.on('languageChanged', (lng: string) => {
  document.documentElement.lang = lng;
});

createRoot(document.getElementById("root")!).render(<App />);

registerServiceWorker();
